import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';

var Goo = function Goo(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$composite = _ref.composite,
      composite = _ref$composite === void 0 ? false : _ref$composite,
      _ref$intensity = _ref.intensity,
      intensity = _ref$intensity === void 0 ? 'medium' : _ref$intensity,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'gooey-react' : _ref$id,
      style = _ref.style;
  var blur = intensity === 'weak' ? 8 : intensity === 'strong' ? 16 : 12;
  var alpha = blur * 6;
  var shift = alpha / -2;
  var r = '1 0 0 0 0';
  var g = '0 1 0 0 0';
  var b = '0 0 1 0 0';
  var a = "0 0 0 ".concat(alpha, " ").concat(shift);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    style: {
      pointerEvents: 'none',
      position: 'absolute'
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    id: id
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: blur
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "".concat(r, " ").concat(g, " ").concat(b, " ").concat(a)
  }), composite && /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("div", {
    className: className,
    style: _objectSpread(_objectSpread({}, style), {}, {
      filter: "url(#".concat(id, ")")
    })
  }, children));
};

export default Goo;